<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g id="TikTok">
      <g id="Icon-7" data-name="Icon">
        <path
          d="M18.437,20.937H5.564a2.5,2.5,0,0,1-2.5-2.5V5.563a2.5,2.5,0,0,1,2.5-2.5H18.437a2.5,2.5,0,0,1,2.5,2.5V18.437A2.5,2.5,0,0,1,18.437,20.937ZM5.564,4.063a1.5,1.5,0,0,0-1.5,1.5V18.437a1.5,1.5,0,0,0,1.5,1.5H18.437a1.5,1.5,0,0,0,1.5-1.5V5.563a1.5,1.5,0,0,0-1.5-1.5Z"
        />
        <path
          d="M14.135,9.564A6.027,6.027,0,0,0,15.8,10.679a1.015,1.015,0,0,0,1.337-.492,1,1,0,0,0-.492-1.327,4.141,4.141,0,0,1-2.2-2.412,1.218,1.218,0,0,0-2.322.513V14.3a1.923,1.923,0,0,1-1.384,1.885,1.857,1.857,0,0,1-2.319-1.942A1.973,1.973,0,0,1,10,12.557a1.019,1.019,0,0,0,.758-1.154,1,1,0,0,0-1.166-.814A3.865,3.865,0,1,0,13.782,16a3.491,3.491,0,0,0,.281-1.419Z"
        />
      </g>
    </g>
  </svg>
</template>
